import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    fill: '#ffffff',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
  <svg
      className={classes.svg}
      viewBox="0 0 200 220"
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
  >
    <path
        d="M86.85,51.8c0-6.7,0-18.1,13.1-18.1s13.1,11.4,13.1,18.1v98c0,5.2,0,18.1-13.1,18.1s-13.1-12.9-13.1-18.1V51.8z M41.15,145.9c0,35.2,22.6,55.9,58.8,55.9c36.2,0,58.8-20.7,58.8-55.9v-90.1c0-38.7-24.8-55.9-58.8-55.9s-58.8,17.2-58.8,55.9V145.9z"/>
  </svg>
  );
};

export default LogoIcon;
